import { ICampaignResponse, IProduct } from '@vfit/consumer/data-access';

export interface ICoverageToolModalProps {
  backgroundImage: string;
  customRedirect?: () => void;
  isOpen?: boolean;
  product?: IProduct;
  handleClose?: () => void;
}

export interface IModalConfig {
  isOpen: boolean;
  title?: string;
  description?: string;
  subDesc?: JSX.Element;
  firstActionLabel?: string;
  firstAction?: () => void;
  secondActionLabel?: string;
  secondAction?: () => void;
  onCloseAction?: () => void;
}

export enum ICoverageToolType {
  MANUAL,
  AUTO,
  MAPS,
  ERROR,
}

export interface IAddressObject {
  city: string | undefined;
  postalCode: string | undefined;
  stateOrProvince: string | undefined;
  street: string | undefined;
  streetNumber: string | undefined;
}

export interface IInputs extends IAddressObject {
  placeId: string | undefined;
  latitude?: number;
  longitude?: number;
  completeAddress?: string;
  isHiddenStreetNumber?: boolean;
  region?: string | undefined;
}

export interface IInputsCoverageTool extends IInputs {
  typeCoverage?: ICoverageToolType;
}

export interface IInputsCoverageToolError extends IInputsCoverageTool {
  showInModal?: boolean;
  errorType?: number;
}
export enum ICheckLockin {
  GO_TO_OFFER,
  NO_COVERAGE,
  NO_OFFER_FOUND,
}

export interface ICoverageToolProps {
  onSubmit?: () => void;
  onBack?: () => void;
  state?: IInputs;
  offerId: string;
  setState?: (state: IInputs) => void;
  onReset?: () => void;
  onCloseError?: () => void;
}

export interface IGeoAddressElab {
  placeId?: string;
  street: string;
  streetNumber?: string;
  city: string;
  province: string;
  postalCode: string;
  latitude?: string;
  longitude?: string;
  region?: string;
}

export interface ICSSProps {
  isManual?: boolean;
}

export interface ICheckEligibility {
  eligible: boolean;
  lockInOffer?: ICampaignResponse;
  lockInProduct?: IProduct;
  errorCode?: string;
}
